import { ComponentFactoryResolver, ComponentRef, Directive, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { InputComponent } from '../input/input.component';
import { SelectComponent } from '../select/select.component';
import { DateComponent } from '../date/date.component';
import { DateTimeComponent } from '../date-time/date-time.component';
import { BooleanComponent } from '../boolean/boolean.component';
import { PriceComponent } from '../price/price.component';
import { TextAreaComponent } from '../text-area/text-area.component';
import { MultiSelectComponent } from '../multi-select/multi-select.component';
import { FieldConfig } from '../field-interface';
import { FileUploadGComponent } from '../file-upload-g/file-upload-g.component';
import { FileUploadPdfComponent } from '../file-upload-pdf/file-upload-pdf.component';
import { Constant } from 'src/app/constant/constant';
import { Router } from '@angular/router';
import { MultipleImagesComponent } from '../multiple-images/multiple-images.component';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { PhoneNoComponent } from '../phone-no/phone-no.component';


const componentMapper = {
  text: InputComponent,
  select: SelectComponent,
  date: DateComponent,
  datetime: DateTimeComponent,
  dateTime: DateTimeComponent,
  'date-time': DateTimeComponent,
  datetimepicker: DateTimeComponent,
  boolean: BooleanComponent,
  textarea: TextAreaComponent,
  phoneno:PhoneNoComponent,
  multiselect: MultiSelectComponent,
  price:PriceComponent,
  decimal:PriceComponent,
  weight:PriceComponent,
  file:FileUploadGComponent,
  filePdf:FileUploadGComponent,
  files:MultipleImagesComponent,
  autocomplete:AutocompleteComponent,
  link:InputComponent,
  image: FileUploadGComponent,
  image_upload: FileUploadGComponent,
  file_upload: FileUploadGComponent,
  upload: FileUploadGComponent,
  media_image: MultipleImagesComponent,
  gallery: MultipleImagesComponent,
  undefined:"",
  2:""
};


@Directive({
  selector: '[dynamicField]'
})
export class DynamicFieldDirective implements OnInit  {

  @Input() field: FieldConfig['eavAttribute'];

    @Input() eavEntityAttribute:any;

  @Input() data: UntypedFormGroup;

  @Input() group: UntypedFormGroup;

  @Output() valueChange = new EventEmitter();

  b2bPricingEnabled:any;
  componentRef: any;
  configService: any;
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef,
    private router: Router,
  ) { }
  ngOnInit() {

    

    if(this.field['isVisible']==1){
      if(this.field.frontendInput !=null  && this.field.frontendLabel
         !=null && this.field.frontendInput!=null && this.field.frontendInput!=undefined) {
        const factory = this.resolver.resolveComponentFactory(
        
          componentMapper[this.field.frontendInput]
        );
        
        this.componentRef = this.container.createComponent(factory);
        this.componentRef.instance.field = this.field;
        this.componentRef.instance.data=this.data;
     
        this.componentRef.instance.group = this.group;

        this.componentRef.instance.eavEntityAttribute=this.eavEntityAttribute;

        this.valueChange.emit(this.group.value);
    }else{
    //  console.log(this.field);
    }
    
   
  }
}




}
